import { useMutation } from '@tanstack/react-query';
import { enqueueSnackbar } from 'notistack';
import { useIntl } from 'react-intl';

// common
import useService from 'common/hook/useService';

// screen
import { handleException } from 'modules/account/detail/helpers/utils';

interface MutatingProps {
  userId: string;
  userActiveStatus: boolean;
  newUserInfo: {
    title: string;
    name: string;
    email: string;
    expiredAt: string | null;
    miscData: {
      Phone: string;
      JobPosition?: string;
      Address?: string;
      IdDoc?: string;
      IdDocIssuedAt?: string;
      IdDocIssuedBy?: string;
      Dob?: string;
      Gender?: string;
    };
  };
}

const useUpdateAccountInfo = () => {
  const { formatMessage } = useIntl();
  const service = useService();

  return useMutation({
    mutationFn: async (props: MutatingProps) => {
      try {
        if (!service) return null;

        const { userId, userActiveStatus, newUserInfo } = props;

        const res = await service.UserManagementController_editUserData({
          params: { userId },
          body: newUserInfo,
          queries: { activate: userActiveStatus },
        });

        if (!res) return null;
        return { message: 'successful' };
      } catch (error) {
        if (handleException(error, { notifyUser: false })) {
          enqueueSnackbar({
            message: formatMessage({
              id: 'account.error.failToUpdateUserInfo',
            }),
            variant: 'error',
          });
        }
        throw error;
      }
    },
  }).mutateAsync;
};

export default useUpdateAccountInfo;
